<template>
  <t-default-layout
    v-bind="$store.state.user"
    :current-user-info="currentUserInfo"
    :handle-online-status-change="handleOnlineStatusChange"
    :handle-logout="handleLogout"
    :current-call-info="currentCallInfo"
    :current-incoming-call-info="currentIncomingCallInfo"
    :notice-list="noticeList"
    @update-calling-modal-fullscreen="updateFullscreenState"
    @update-client-list="handleGetClientList"
    @update-memo-empty-status="updateMemoEmptyStatus"
    @sync-memo="syncMemo"
  >
    <router-view
      v-bind="$store.state.user"
      :current-user-info="currentUserInfo"
      :handle-logout="handleLogout"
      :is-calling="isCalling"
      :hang-up-click="handleHangUpClick"
      :input-devices="inputDevices"
      :speaker-devices="speakerDevices"
      :outbound-props="outboundProps"
      :current-call-sid="currentCallSid"
      :client-list="clientList"
      :notice-list="noticeList"
      :set-loading="setLoading"
      :show-info-modal="showInfoModal"
      :show-error-modal="showErrorModal"
      @call="handleCall"
      @update:current-number="handleNumberChange"
      @update:current-client-list="handleClientListChange"
      @update:update-speaker="handleSpeakerSelectionChange"
      @update:update-microphone="handleMicrophoneSelectionChange"
    ></router-view>
    <o-modal
      id="index_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
    <loading :active="isLoading" :is-full-page="true" :height="100" :width="100"></loading>
  </t-default-layout>
</template>

<script>
import TDefaultLayout from '@/components/templates/default-layout/index-service-ongoing.vue';
import { Device } from '@twilio/voice-sdk';
import { SyncClient } from 'twilio-sync';
import { customRequest } from '@/common/customRequest.js';
import { mapActions } from 'vuex';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { statusConst, BUSINESS_HOUR_STATUS } from '@/libs/constants';
import { utils } from '@/common/utils.js';
import { markRaw } from 'vue';
import { chkTrialCompanyID } from '@/libs/utils';
import { DEFAULT_DEVICE, WITHHELD_NUMBERS, WITHHELD_NUMBER_ALIAS, USER_STATUSES } from '@/libs/constants';
import Firebase from '@/common/firebase';
import { cloneDeep } from 'lodash';
import Loading from 'vue-loading-overlay';
export default {
  name: 't-index-service-ongoing',
  components: { TDefaultLayout, Loading },
  mixins: [customRequest, customValidate, utils],
  data: function () {
    return {
      memo: ``,
      currentCallInfo: null,
      currentIncomingCallInfo: null,
      customerInfo: {
        title: '',
        phoneNumber: '',
        subtitle: '',
        rawPhoneNumber: '',
      },
      selectedCurrentClient: {},
      //Call event, flag
      selectedCompanyID: '',
      directionFlg: '',
      isbuttonCall: '',

      //Twilio Device
      clientList: [],
      forwardingUserList: [],
      device: null,
      ringtoneDeviceSelected: '',
      speakerDeviceSelected: '',
      inputDeviceSelected: '',
      ringtoneDevices: [],
      speakerDevices: [],
      inputDevices: [],
      //Sync document
      sync: null,
      syncDocument: null,

      //保留
      pendingActiveId: '',
      pendingAvailableList: [],
      currentOnHoldList: [],
      currentPendingAvailableList: [],

      //Modal
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,

      // 営業時間チェック
      businessHourStatus: BUSINESS_HOUR_STATUS.OUT_OF_SERVICE,

      //Outgoing modal
      isCalling: false,
      handleHangUpClick: () => {},

      //Hold interval
      queueCheckInterval: null,

      // logged-out status
      isLoggedOut: false,

      //SyncMap for memo syncronization
      memoSyncMap: null,

      //RingingBack Tone
      ringingBackTone: null,

      // 着信しているかどうかチェック
      isIncomming: false,

      // 通知インスタンス
      notificationInstance: {
        incoming: null,
        onhold: {
          park_1: null,
          park_2: null,
          park_3: null,
        },
        sessionAboutToExpire: null,
      },

      // 通知のON／OFF設定
      notificationFlag: null,

      // ソフトフォンの状態
      callingModalFullscreen: false,
      callingModalMemoEmpty: true,

      // 転送、保留カウント
      limitCountData: null,

      //Error occur flag
      hasError: false,

      // Salesforceからの取得情報
      sfInfo: {},
      sfAvailable: false,

      // アウトバウンド用データ
      outboundProps: { isCalling: false, hasNewCall: false, isTalking: false, conn: null, rejectCall: null },

      // 現在対象となっているCallSid(SFソフトフォン用)
      currentCallSid: null,

      // 作成されたSalesforceケースのID
      createdCaseId: null,

      // Online statuses
      onlineStatuses: [],

      // 内線発信かどうかフラグ
      isExtensionCallOutbound: false,

      //Firebase
      firebase: null,
      onlineStatusData: {},
      callingStatusData: {},

      // セッションの有効期限切れる警告
      sessionAboutToExpire: false,

      isLoading: false,

      // callSidはTJSのタイプの場合、相手は切断済でも発信側は発信の状況のままで表示されるため数秒ごとに切断済かチェック
      callAliveCheckInterval: null,

      // お知らせデータ
      noticeList: [],
    };
  },
  computed: {
    onlineStatus() {
      return this.$store.state.onlineStatus;
    },
    businessHour() {
      return this.$store.state.businessHour;
    },
    clientName() {
      return this.$store.state.user.clientName;
    },
    companyID() {
      return this.$store.state.user.companyID;
    },
    agentName() {
      return this.$store.state.user.username;
    },
    userID() {
      return this.$store.state.user.userID;
    },
    assetsHost() {
      return this.$store.state.user.assetsHost;
    },
    currentUserInfo() {
      return {
        online: this.$store.state.onlineStatus ? true : false,
        business_hour: this.$store.state.businessHour,
        name: this.$store.state.user.username ? this.$store.state.user.username : '',
        company_id: this.$store.state.user.companyID ? this.$store.state.user.companyID : '',
        phone_number: this.$store.state.user.phoneNumber ? this.$store.state.user.phoneNumber : '',
        auth_info: this.$store.state.user.authInfo ? this.$store.state.user.authInfo : '',
        edit_profile_url: '#1',
        logout_url: '#2',
        clientName: this.$store.state.user.clientName ? this.$store.state.user.clientName : '',
      };
    },
    selectedCurrentNumber() {
      return this.$store.state.user.phoneNumber;
    },
    formatSelectedCurrentNumber() {
      return this.formatSysTemCallNumber(this.$store.state.user.phoneNumber);
    },
    isTrial() {
      return this.companyID && this.companyID.match(/^tri[0-9]{6}$/);
    },
  },
  watch: {
    isCalling(val) {
      this.outboundProps.isCalling = val;
    },
    currentCallInfo(val) {
      this.outboundProps.isTalking = !!val;
    },
    currentIncomingCallInfo(val) {
      this.outboundProps.hasNewCall = val ? val.hasNewCall : false;
    },
    sessionAboutToExpire(val) {
      if (val) {
        this.checkNotificationPermission()
          .then(result => {
            if (result === 'granted') {
              if (this.notificationFlag === true) {
                this.notificationInstance.sessionAboutToExpire = new Notification('COTOHA Call Center', {
                  body: messageContent.sessionAboutToExpireWarning,
                });
                this.notificationInstance.sessionAboutToExpire.onclick = event => {
                  event.preventDefault();
                  window.focus();
                  this.notificationInstance.sessionAboutToExpire.close();
                };
              }
            }
          })
          .catch(() => {});
      }
    },
  },
  async created() {
    await this.handleGetClientList();
    this.updateAgentCallingStatus(false, this.getCookie('CallSid'));
    this.outboundProps.rejectCall = this.handleRejectCallClick;

    const AudioContext = window.AudioContext || window.webkitAudioContext;
    const audioContext = new AudioContext();
    if (audioContext.state !== 'running') {
      this.showInfoModal(messageContent.notifyPageRefreshed);
    }
    audioContext.close();
  },
  async mounted() {
    setInterval(this.sessionAboutToExpireCheck, 5000);
    // ページロードすると対応可能になる
    // このロジックはstep11にマージしない #3821
    if (this.clientName) {
      this.handleRequestToken();
    }
    const ringingBackToneURL = `/public/assets/RingBackTone.mp3`;
    const audio = new Audio(ringingBackToneURL);
    audio.loop = true;
    this.ringingBackTone = audio;
    const self = this;
    audio.onerror = function () {
      //Ringbacktone not found
      self.ringingBackTone = null;
    };

    // 通知のON／OFF設定
    await this.postRequest('/idmgmt/getNotificationFlag', { companyID: this.companyID, userID: this.userID }).then(
      e => {
        if (e.data) {
          if (e.data.flag === null || typeof e.data.flag === 'undefined') {
            this.notificationFlag = null;
          } else {
            this.notificationFlag = e.data.flag;
          }
        } else {
          this.notificationFlag = null;
        }
      }
    );

    if (this.notificationFlag === null) {
      await this.postRequest('/idmgmt/setNotificationFlag', {
        companyID: this.companyID,
        userID: this.userID,
        data: {
          notificationFlag: true,
        },
      }).then(e => {
        if (e.status) {
          this.notificationFlag = true;
        }
      });
    }

    // 通知の許可設定
    if (this.notificationFlag === true) {
      this.checkNotificationPermission().then(result => {
        console.log(result);
      });
    }

    // Salesforce連携設定の読み込み
    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });

    //firebase
    const firebaseConfig = this.$store.state.user.firebaseConfig;
    if (firebaseConfig) {
      //Firebaseをログインされたかどうか、確認
      this.firebase = new Firebase();
      this.firebase.initializeApp(firebaseConfig);
      const authen = await this.firebase.onAuthenticate();

      authen.onAuthStateChanged(user => {
        //Firebaseをログインされた場合
        if (user && this.clientName !== user.uid) {
          console.log('different user');
          this.firebase.signOut();
          return;
        }
        if (user) {
          this.unsubscriberOnlineStatus();
          this.unsubscriberCallingStatus();
          this.unsubscriberParkHold();
          this.unsubscriberHold();
          this.unsubscriberTransfer();
          this.unsubscriberNotifyMessageInfo();
        } else if (!this.isLoggedOut && this.$route.meta.requiresAuth) {
          //ログアウトした場合、Firebaseを使用しない
          //Firebaseをログインされていない場合
          const self = this;
          this.firebase
            .refreshToken(async token => {
              if (token) {
                await this.firebase.login(token);
              }
            })
            .then(result => {
              self
                .postRequest('/token/refresh-firebase-token')
                .then(async result => {
                  if (result.status === 'success') {
                    await this.firebase.login(result.data.token);
                  }
                })
                .catch(err => {
                  console.debug(err);
                });
            })
            .catch(err => {
              console.debug(err);
            });
        }
      });
    }
  },
  methods: {
    ...mapActions(['updateOnlineStatus', 'updateBusinessHour']),
    //Status
    handleOnlineStatusChange(onlineStatus) {
      this.updateAgentStatus(onlineStatus);
    },

    setLoading(value) {
      this.isLoading = !!value;
    },

    sessionAboutToExpireCheck() {
      const latestRequestTime = this.$store.state.latestRequestTime;
      if (!latestRequestTime) return;
      const sessionLifetime = this.$store.state.user.sessionLifetime;
      if (!sessionLifetime) return;

      const currentTime = new Date().getTime();
      const alertTimeInMs = (sessionLifetime - 1) * 60 * 60 * 1000;
      this.sessionAboutToExpire = currentTime - latestRequestTime >= alertTimeInMs;
    },

    handleLogout() {
      if (this.firebase && this.firebase.isInitial) this.firebase.signOut();
      this.isLoggedOut = true;
    },

    /**Twilio token created
     * @param companyID (selectedCompany)
     * @param identity (clientName)
     */
    handleRequestToken() {
      const self = this;
      this.postRequest('/token')
        .then(function (e) {
          if (e.status === 'success') {
            if (!self.device) {
              const options = {
                // Set Opus as our preferred codec. Opus generally performs better, requiring less bandwidth and
                // providing better audio quality in restrained network conditions. Opus will be default in 2.0.
                codecPreferences: ['opus', 'pcmu'],
                // Use fake DTMF tones client-side. Real tones are still sent to the other end of the call,
                // but the client-side DTMF tones are fake. Thissetups will be default in 2.0.
                fakeLocalDTMF: true,
                // Use `enableRingingState` to enable the device to emit the `ringing`
                // state. The TwiML backend also needs to have the attribute
                // `answerOnBridge` also set to true in the `Dial` verb. This option
                // changes the behavior of the SDK to consider a call `ringing` starting
                // from the connection to the TwiML backend to when the recipient of
                // the `Dial` verb answers.
                enableRingingState: true,
                edge: 'tokyo',
                debug: true,
                // sounds: {
                //   dtmf1: 'https://api.twilio.com/cowbell.mp3'
                // },
                closeProtection: true,
              };
              self.device = markRaw(new Device(e.data.token, options));
              self.handleInitialDevice();

              //Device must be registered in order to receive incoming calls
              self.device.register();

              //Sync
              self.handleSyncDocument(e.data.token);
            } else {
              //TokenがExipredなら、更新する
              self.device.updateToken(e.data.token);
            }

            // Update agent status
            self.updateOnlineStatus(e.data.agentStatus);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleInitialDevice() {
      const self = this;

      this.device.on('error', function (error) {
        self.outboundProps.conn = null;
        console.log('Twilio.Device Error: ' + error.message);
        if (error.code === 20104) {
          //Token expire
          self.handleRequestToken();
        } else {
          if (this.currentCallInfo) this.currentCallInfo.isLoading = false;
          self.hasError = false;
          self.$router.go({ path: '/home', force: true });
        }
      });

      //着信したらここに飛ぶようにする
      this.device.on('incoming', function (conn) {
        self.outboundProps.conn = conn;
        self.updateAgentCallingStatus(true);
        self.isIncomming = true;
        self.connection = conn;
        self.setDirectionUI('inbound');
        self.handleSettingIncomingCallInfo(conn);
      });

      this.device.audio.on('deviceChange', self.updateAllDevices.bind(self.device));

      if (this.device.audio.isOutputSelectionSupported) {
        //console.log('audio output support');
      }
    },
    handleCloseCall() {
      this.outboundProps.conn = null;
      const self = this;
      if (self.currentCallInfo) {
        if (self.currentCallInfo.status !== 'onhold') {
          self.currentCallInfo.isAcw = false;
          self.currentCallInfo.status = 'ended';
          self.currentCallInfo = null;
          self.handleSettingIncomingCallInfo(null);
          self.updateAgentCallingStatus(false);
          self.$router.go({ path: '/home', force: true });
        }
      }
    },
    async handleSettingIncomingCallInfo(conn) {
      if (!this.currentIncomingCallInfo) this.currentIncomingCallInfo = {};
      const self = this;
      let agentName = '';
      let incomingMessage = '';
      const currentSpeaker = localStorage.getItem('speakerId');

      if (this.device) {
        try {
          //speaker
          await this.device.audio.speakerDevices.set(currentSpeaker);
          //ringtone
          await this.device.audio.ringtoneDevices.set(currentSpeaker);
        } catch (e) {
          console.info(e);
          try {
            //speaker
            await this.device.audio.speakerDevices.set(DEFAULT_DEVICE);
            //rington
            await this.device.audio.ringtoneDevices.set(DEFAULT_DEVICE);
          } catch (e) {
            console.log(e);
          }
        }
      }

      if (conn) {
        // 外線か内線か判断
        if (conn.parameters.From.match(/^\+81/) !== null || this.isPhoneNumber(conn.parameters.From)) {
          let contactlistName = '';
          await this.postRequest('/contactlist/getcontactdata', {
            contactID: conn.parameters.From.replace('+81', '0'),
            companyID: this.companyID,
          })
            .then(parameters => {
              if (parameters.data) {
                contactlistName = parameters.data.view_name;
              }
            })
            .catch(err => {
              //console.log(err);
            });

          const fromTelNumber = self.formatCallerNumber(conn.parameters.From);
          const incomingCallName = contactlistName ? contactlistName : fromTelNumber;
          self.customerInfo = {
            phoneNumber: fromTelNumber,
            rawPhoneNumber: conn.parameters.From,
            title: incomingCallName,
            subtitle: conn.customParameters.get('departmentName'),
          };

          const pushNumberSettingName = conn.customParameters.get('pushNumberSettingName');
          const pbSettingName = self.collapseText(pushNumberSettingName, 10);
          incomingMessage = pbSettingName
            ? `プッシュ番号設定名称：${pbSettingName}\n${incomingCallName}から着信が来ています。`
            : `${incomingCallName}から着信が来ています。`;

          // 着信元番号・名称
          const telNumber = (conn.customParameters.get('Called') || '').replace('+81', '0');
          const telNumbersInfo = await this.postRequest('/home/fetchAvailableTelNumbers');
          let numberName;
          if (telNumbersInfo && telNumbersInfo.telNumbers) {
            numberName = telNumbersInfo.telNumbers[telNumber];
          }
          self.currentIncomingCallInfo.telNumberInfo = { telNumber, numberName };
          incomingMessage += `\n番号名称：${self.collapseText(numberName || '未設定', 10)}　自番号：${telNumber}`;
        } else {
          const fromNumber = self.formatCallerNumber(
            conn.parameters.From ? conn.parameters.From.replaceAll('_', '-') : conn.parameters.From,
            conn
          );
          agentName = conn.customParameters.get('agentName');
          self.customerInfo = {
            phoneNumber: fromNumber,
            rawPhoneNumber: conn.parameters.From ? conn.parameters.From.replaceAll('_', '-') : conn.parameters.From,
            title: fromNumber,
            subtitle: '', //TODO: get subtile
          };

          if (!fromNumber) {
            incomingMessage = '着信が来ています。';
          } else {
            incomingMessage = fromNumber + 'から着信が来ています。';
          }
        }
        self.currentIncomingCallInfo.customerInfo = self.customerInfo;
        // Set pbSettingName
        self.currentIncomingCallInfo.pushNumberSettingName = conn.customParameters.get('pushNumberSettingName');
        self.currentIncomingCallInfo.hasNewCall = true;
        self.outboundProps.hasNewCall = true;
        // document.cookie = `CallSid=${conn.parameters.CallSid}`;
        self.setCookie('CallSid', conn.parameters.CallSid);
        self.currentCallSid = conn.parameters.CallSid;
        self.customerPhoneNumber = agentName ? agentName : conn.parameters.From;
        self.currentIncomingCallInfo.responseStatusList = [
          {
            label: '着信番号',
            value: agentName
              ? agentName
              : self.formatCallerNumber(
                  conn.parameters.From ? conn.parameters.From.replaceAll('_', '-') : conn.parameters.From
                ),
          },
        ];
        self.currentIncomingCallInfo.twilioCalledNumber = conn.customParameters.get('Called');
        self.currentIncomingCallInfo.handleRejectCallClick = function () {
          return self.handleRejectCallClick(conn);
        };
        self.currentIncomingCallInfo.handleReceiveCallClick = function () {
          return self.handleReceiveCallClick(conn);
        };

        //notification
        self
          .checkNotificationPermission()
          .then(result => {
            if (result === 'granted') {
              if (self.notificationFlag === true) {
                self.notificationInstance.incoming = new Notification('COTOHA Call Center', {
                  body: incomingMessage,
                  icon: '',
                  tag: '',
                  data: {},
                });
                self.notificationInstance.incoming.onclick = event => {
                  event.preventDefault();
                  window.focus();
                  self.notificationInstance.incoming.close();
                };
              }
            }
          })
          .catch(() => {});

        conn.on('accept', this.handleAcceptIncomingCall);
        conn.on('cancel', this.handleCancelCall);
        conn.on('disconnect', this.handleDisconnectCall);
      }

      self.currentIncomingCallInfo.onholdList = self.currentOnHoldList;
      self.currentIncomingCallInfo.hasNewOnHold = self.checkNewHold(self.currentOnHoldList);
      self.currentIncomingCallInfo.handleOnholdButtonClick = function (parkId) {
        return self.handleOnholdButtonClick(parkId);
      };

      // 長安用場合、着信を受けたらポップアップを出さずに即通話開始
      const chouan = Boolean(parseInt(self.getCookie('chouan')));
      //console.log('長安用：', chouan);
      if (conn && chouan) {
        self.handleReceiveCallClick(conn);
      }

      if (self.currentIncomingCallInfo) {
        self.currentIncomingCallInfo.sfCases = [
          {
            sfSubject: '',
            CreatedDateStr: '',
            sfOperator: '',
          },
        ];
        self.currentIncomingCallInfo.sfContactInfo = [{ Name: '<取引先責任者未登録>' }];
        if (self.currentIncomingCallInfo.customerInfo) {
          // 過去の通話履歴(ケース)を検索
          await self
            .postRequest('/callLogClient/getSfCases', {
              phoneNumber: self.currentIncomingCallInfo.customerInfo.phoneNumber,
            })
            .then(e => {
              if (e.data) {
                self.currentIncomingCallInfo.sfCases = e.data.resultCases;
              }
            })
            .catch(err => {
              console.error(err);
            });
          // Salesforce連絡先情報を検索
          await self
            .postRequest('/callLogClient/getSfContactInfo', {
              phoneNumber: self.currentIncomingCallInfo.customerInfo.phoneNumber,
            })
            .then(e => {
              if (e.data) {
                self.currentIncomingCallInfo.sfContactInfo = e.data.contactRecords;
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      }
    },

    async handleSettingCurentCallInfo(conn) {
      if (!this.currentCallInfo) {
        this.currentCallInfo = {};
        this.currentCallInfo.responseStatusList = [];
        this.currentCallInfo.customerInfo = {};
      }
      const self = this;
      //let responseStatusList = [];
      if (conn) {
        self.currentCallInfo.handleEndCallButtonClick = function () {
          // リロード対応　ダイアログを解除
          window.removeEventListener('beforeunload', this.handleUnlock);
          return self.handleEndCallButtonClick(conn);
        };
        self.currentCallInfo.handleCloseCall = function () {
          return self.handleCloseCall();
        };
        const customerInfo = self.getCustomerInfo(conn);
        self.currentCallInfo.responseStatusList = customerInfo.responseStatusList;
        self.currentCallInfo.customerInfo = customerInfo.customerInfo;
        if (self.directionFlg === 'outbound-dial') {
          //発信
          //console.log("発信");
          //転送許可設定 発信側&相手が内線であればfalse、それ以外はtrue
          const checkStr = self.currentCallInfo.customerInfo.phoneNumber;
          if (!checkStr || !checkStr.match(/^[0-9]+$/)) {
            self.currentCallInfo.isTransferOk = false;
            self.isExtensionCallOutbound = true;
          } else {
            self.currentCallInfo.isTransferOk = true;
            self.isExtensionCallOutbound = false;
          }
          if (conn.customParameters.get('Type') !== 'resume' && self.isbuttonCall === 'on') {
            self.setCookie('CallSid', conn.parameters.CallSid);
            self.currentCallSid = conn.parameters.CallSid;
            //最初の５秒をパーク保留ボタン、保留ボタンを無効
            self.currentCallInfo.isHoldCountExceeded = true;
            setTimeout(function () {
              if (self.currentCallInfo) self.currentCallInfo.isHoldCountExceeded = false;
            }, 5000);
          }
        } else {
          self.currentCallInfo.isTransferOk = true;
          self.isExtensionCallOutbound = false;
        }

        self.currentCallInfo.microphoneListOptions = self.inputDevices;
        self.currentCallInfo.speakerListOptions = self.speakerDevices;
        self.currentCallInfo.microphone = self.inputDeviceSelected;
        self.currentCallInfo.speaker = self.speakerDeviceSelected;
        self.currentCallInfo.status = 'active';
        self.currentCallInfo.callingTime = ''; //TODO: handle this
        self.currentCallInfo.pendingActiveId = '';
        self.currentCallInfo.pendingAvailableList = self.currentPendingAvailableList;
        if (!self.currentCallInfo.customerInfo) self.currentCallInfo.customerInfo = {};
        //self.currentCallInfo.memo = self.memo;
        //userlist TODO get userlist
        self.currentCallInfo.forwardingUserList = self.forwardingUserList;
        const pbSettingName = conn.customParameters.get('pushNumberSettingName');
        if (pbSettingName && pbSettingName !== 'undefined') {
          self.currentCallInfo.pushNumberSettingName = pbSettingName;
        }
        if (typeof conn.customParameters.get('isReachHoldCountLimit') !== 'undefined') {
          self.currentCallInfo.isHoldCountExceeded = conn.customParameters.get('isReachHoldCountLimit') === 'true';
        }
        if (typeof conn.customParameters.get('isReachTransferCountLimit') !== 'undefined') {
          self.currentCallInfo.isTransferCountExceeded =
            conn.customParameters.get('isReachTransferCountLimit') === 'true';
        }
        if (self.limitCountData) {
          self.currentCallInfo.isHoldCountExceeded = self.limitCountData.isReachHoldCountLimit;
          self.currentCallInfo.isTransferCountExceeded = self.limitCountData.isReachTransferCountLimit;
          self.limitCountData = null;
        }
        // 着信元番号・名称
        const Called = conn.customParameters.get('Called');
        if (Called) {
          const telNumber = Called.replace('+81', '0');
          const telNumbersInfo = await this.postRequest('/home/fetchAvailableTelNumbers');
          let numberName;
          if (telNumbersInfo && telNumbersInfo.telNumbers) {
            numberName = telNumbersInfo.telNumbers[telNumber];
          }
          self.currentCallInfo.telNumberInfo = { telNumber, numberName };
        }
      }

      self.currentCallInfo.isLoading = false;
      self.currentCallInfo.handleMicrophoneSelectionChange = function (microphone) {
        return self.handleMicrophoneSelectionChange(microphone);
      };
      self.currentCallInfo.handleSpeakerSelectionChange = function (speaker) {
        return self.handleSpeakerSelectionChange(speaker);
      };
      self.currentCallInfo.handleCallHistoryButtonClick = function () {
        return self.handleCallHistoryButtonClick(conn);
      };
      self.currentCallInfo.handleContactListButtonClick = function () {
        return self.handleContactListButtonClick(conn);
      };
      self.currentCallInfo.handleHoldButtonClick = function (isHolding) {
        return self.handleHoldButtonClick(isHolding);
      };
      self.currentCallInfo.handleTransferCallSubmit = function (payload) {
        return self.handleTransferCallSubmit(payload);
      };
      self.currentCallInfo.handleNumpadClick = function (digit) {
        return self.handleNumpadClick(conn, digit);
      };

      self.currentCallInfo.handleEndFormSubmit = function (payload) {
        return self.handleEndFormSubmit(payload);
      };
      self.currentCallInfo.handleOnholdActivateButtonClick = function (itemId) {
        return self.handleOnholdActivateButtonClick(itemId);
      };
      self.currentCallInfo.handleOnholdDeactivateButtonClick = function (itemId) {
        return self.handleOnholdDeactivateButtonClick(itemId);
      };

      // Salesforce取引先責任者・履歴取得
      self.currentCallInfo.sfCurrentInfo = {};
      self.currentCallInfo.sfCurrentInfo.sfCases = [
        {
          sfSubject: '',
          CreatedDateStr: '',
          sfOperator: '',
        },
      ];
      self.currentCallInfo.sfCurrentInfo.sfContactInfo = [{ Name: '<取引先責任者未登録>' }];
      if (self.currentCallInfo.customerInfo) {
        await self
          .postRequest('/callLogClient/getSfCases', { phoneNumber: self.currentCallInfo.customerInfo.phoneNumber })
          .then(e => {
            if (e.data) {
              self.currentCallInfo.sfCurrentInfo.sfCases = e.data.resultCases;
              for (const sfCase of self.currentCallInfo.sfCurrentInfo.sfCases) {
                const createdDateObj = new Date(sfCase.sfCreatedDate);
                const createdDateStr = createdDateObj.toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
                const createdTimeStr = createdDateObj.toLocaleTimeString('ja-JP', { timeZone: 'Asia/Tokyo' });
                sfCase.CreatedDateStr = createdDateStr + ' ' + createdTimeStr;
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
        await self
          .postRequest('/callLogClient/getSfContactInfo', {
            phoneNumber: self.currentCallInfo.customerInfo.phoneNumber,
          })
          .then(e => {
            if (e.data) {
              self.currentCallInfo.sfCurrentInfo.sfContactInfo = e.data.contactRecords;
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    getCustomerInfo(conn) {
      const callInfo = {};
      callInfo.customerInfo = {};
      callInfo.responseStatusList = [];
      const type = conn.customParameters.get('Type');
      if (this.directionFlg === 'outbound-dial') {
        if (type === 'resume') {
          //保留取得、
          //console.log('保留取得');
          const toPhoneNumber = this.formatCallerNumber(conn.customParameters.get('CustomerPhoneNumber'));
          callInfo.responseStatusList.push({ label: '発信番号', value: toPhoneNumber });
          callInfo.customerInfo = { phoneNumber: toPhoneNumber, title: conn.customParameters.get('CustomerTitle') };
        } else {
          //発信
          const fromPhoneNumber = this.formatCallerNumber(conn.customParameters.get('From'));
          const toPhoneNumber = this.formatCallerNumber(conn.customParameters.get('To'));
          callInfo.responseStatusList.push({ label: '発信番号', value: toPhoneNumber });
          callInfo.customerInfo = { phoneNumber: toPhoneNumber };
        }
      } else {
        //着信
        if (type === 'resume') {
          const toPhoneNumber = this.formatCallerNumber(conn.customParameters.get('CustomerPhoneNumber'));
          callInfo.responseStatusList.push({ label: '着信番号', value: toPhoneNumber });
          callInfo.customerInfo = { phoneNumber: toPhoneNumber, title: conn.customParameters.get('CustomerTitle') };
        } else {
          //着信
          const agentName = conn.customParameters.get('agentName'); //転送
          const phoneNumber = this.formatCallerNumber(
            conn.parameters.From ? conn.parameters.From.replaceAll('_', '-') : conn.parameters.From,
            conn
          );
          callInfo.responseStatusList.push({ label: '着信番号', value: agentName ? agentName : phoneNumber });
          //callInfo.customerInfo = { phoneNumber: phoneNumber };
          callInfo.customerInfo = this.customerInfo;
        }
      }

      return callInfo;
    },
    handleDisconnectDevice() {
      if (this.device) this.device.destroy(); //disconnect all connection
    },
    async handleMicrophoneSelectionChange(microphone) {
      console.debug('handleMicrophoneSelectionChange start');
      this.inputDeviceSelected = microphone;
      console.debug('before change localStorage microphoneId: ', localStorage.getItem('microphoneId'));
      localStorage.setItem('microphoneId', microphone);
      const availableInputpeakerDevices = this.device.audio.availableInputDevices;
      if (microphone !== null) {
        availableInputpeakerDevices.forEach(function (device) {
          console.debug('Available micro Id: ', device.deviceId);
          if (device.deviceId === microphone) {
            localStorage.setItem('microphoneName', device.label.replace(/\(....:....\)/, ''));
          }
        });
      }

      console.debug('before change Twilio microphoneId: ', this.device.audio.inputDevice);
      if (this.device) await this.device.audio.setInputDevice(microphone);
      console.debug('after change Twilio microphoneId: ', this.device.audio.inputDevice);
      console.debug('after change localStorage microphoneId: ', localStorage.getItem('microphoneId'));
      console.debug('handleMicrophoneSelectionChange end');
    },
    async handleSpeakerSelectionChange(speaker) {
      console.debug('handleSpeakerSelectionChange start');
      this.speakerDeviceSelected = speaker;
      console.debug('before change localStorage speakerId: ', localStorage.getItem('speakerId'));
      localStorage.setItem('speakerId', speaker);
      const availableSpeakerDevices = this.device.audio.availableOutputDevices;
      if (speaker !== null) {
        availableSpeakerDevices.forEach(function (device) {
          console.debug('Available speaker Id: ', device.deviceId);
          if (device.deviceId === speaker) {
            localStorage.setItem('speakerName', device.label.replace(/\(....:....\)/, ''));
          }
        });
      }
      console.debug('before change Twilio speakerId: ', this.device.audio.speakerDevices.get());
      if (this.device) {
        await this.device.audio.speakerDevices.set(speaker);
        await this.device.audio.ringtoneDevices.set(speaker);
      }

      console.debug('after change Twilio speakerId: ', this.device.audio.speakerDevices.get());
      console.debug('after change localStorage speakerId: ', localStorage.getItem('speakerId'));
      console.debug('handleSpeakerSelectionChange end');
    },
    handleCallHistoryButtonClick() {},
    handleContactListButtonClick() {},
    handleHoldButtonClick(isHolding) {
      if (isHolding) {
        this.handleHoldCall();
      } else {
        this.handleResumeCall();
      }
    },
    async handleHoldCall() {
      const callsid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      //console.log(`callsid: ${callsid}`);
      const self = this;
      self.currentCallInfo.status = 'onhold';
      self.currentCallInfo.isLoading = true;
      await this.postRequest('/hold', {
        CallSid: callsid,
        Direction: this.directionFlg,
        clientName: this.clientName,
        partnerClient: this.customerInfo.rawPhoneNumber,
      })
        .then(e => {
          if (e.status === 'success') {
            //発信元は切断したかチェック
            self.queueCheckInterval = setInterval(async function () {
              if (!self.currentCallInfo || self.currentCallInfo.status !== 'onhold') {
                clearInterval(self.queueCheckInterval);
              }
              const checkResult = await self.handleGetQueueInfo(callsid);
              if (!checkResult) {
                //エラーが発生、キューをチェックできない
                self.showErrorModal(messageContent.requireTry('保留'));
                clearInterval(self.queueCheckInterval);
              } else if (checkResult.currentMember === 0) {
                //発生元が切断した
                self.setCallEnd();
                clearInterval(self.queueCheckInterval);
              }
            }, 5000);
            // Sync holdCount, transferCount
          } else if (e.status === statusConst.EXCEED_HOLD_COUNT_LIMIT) {
            self.currentCallInfo.status = 'active';
            self.currentCallInfo.isHoldCountExceeded = true;
            self.showErrorModal(messageContent.exceedHoldCountLimit);
          } else if (e.status === 'callIsHolding') {
            if (self.currentCallInfo) {
              self.currentCallInfo.status = 'active';
            }
            self.showErrorModal(messageContent.callIsHolding);
          } else if (e.status === 'updateCallFailed') {
            self.hasError = true;
            if (self.currentCallInfo) {
              self.currentCallInfo.isLoading = false;
              self.currentCallInfo.status = 'active';
            }

            self.showErrorModal(messageContent.notifyCalledDisconnected);
          } else {
            self.hasError = true;
            if (self.currentCallInfo) {
              self.currentCallInfo.status = 'active';
            }
            self.showErrorModal(messageContent.requireTry('保留'));
          }
          if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
        })
        .catch(e => {
          if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
          self.showErrorModal(messageContent.requireTry('保留'));
        });
    },
    async handleResumeCall() {
      if (this.currentCallInfo) this.currentCallInfo.isLoading = true;
      clearInterval(this.queueCheckInterval);
      const callsid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      //console.log("resumeCallsid:" + callsid);
      const checkQueue = await this.handleGetQueueInfo(callsid);
      if (!checkQueue || checkQueue.currentMember === 0) {
        //保留中の発信元が切断
        this.setCallEnd();
        return;
      }
      const Called = this.currentCallInfo.telNumberInfo ? this.currentCallInfo.telNumberInfo.telNumber : '';
      const params = {
        To: callsid,
        From: this.selectedCurrentNumber,
        Type: 'resume',
        DirectionFlg: this.directionFlg,
        CallerNumber: this.formatSelectedCurrentNumber,
        CustomerPhoneNumber: this.customerInfo.rawPhoneNumber,
        CustomerRawPhoneNumber: this.customerInfo.rawPhoneNumber,
        CustomerTitle: this.customerInfo.title,
        companyID: this.companyID,
        userID: this.userID,
        pushNumberSettingName: this.currentCallInfo.pushNumberSettingName,
        Called,
      };

      //発信桁数チェック(nullの場合は発信不可とする)
      if (params.To === null) {
        //console.log("宛先が空です。");
        return;
      }

      //console.log("Calling " + params.To + "...");
      if (this.device) {
        const outgoingConnection = await this.device.connect({ params });
        const self = this;

        outgoingConnection.on('accept', function (conn) {
          //保留を再開と新しいコールを作成したので、このコールのallSidをCookieに保存
          self.setCookie('CallSid', conn.parameters.CallSid);
          self.currentCallSid = conn.parameters.CallSid;
          self.handleAcceptIncomingCall(conn);
        });

        outgoingConnection.on('disconnect', function (conn) {
          self.handleDisconnectCall(conn);
        });
      }
    },
    async handleTransferCallSubmit(payload) {
      const clientId = payload.user;
      let Called;
      if (this.currentCallInfo.telNumberInfo) {
        Called = this.currentCallInfo.telNumberInfo.telNumber;
      }
      const data = {
        Direction: this.directionFlg,
        ClientName: this.clientName,
        TelNumber: this.selectedCurrentNumber,
        companyID: this.companyID,
        agentName: this.agentName,
        pushNumberSettingName: this.currentCallInfo.pushNumberSettingName,
        Called,
        ...payload,
      };

      //発信先が通話可能かチェック
      if (clientId) {
        const result = await this.postRequest('/clientUpdate/getinfo', { clientName: clientId })
          .then(data => {
            if (data.status === 'success') return data.data.callingStatus;
            return true;
          })
          .catch(e => {
            return true;
          });
        if (result) {
          return this.showErrorModal(messageContent.notifyCalledBusy('転送先'));
        }
      }
      const self = this;
      this.currentCallInfo.status = 'transfering';
      this.currentCallInfo.isLoading = true;
      const identity = payload.method === 'user' ? `${self.companyID}-${clientId}` : payload.phone_number;
      this.postRequest('/transfer/' + identity + '/call', data)
        .then(data => {
          if (data.status === 'success') {
            if (self.currentCallInfo) {
              self.currentCallInfo.status = 'transfer';
            }
            return '';
          } else if (data.status === statusConst.EXCEED_TRANSFER_COUNT_LIMIT) {
            self.currentCallInfo.status = 'active';
            self.currentCallInfo.isTransferCountExceeded = true;
            if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
            return self.showErrorModal(messageContent.exceedTransferCountLimit);
          } else if (data.status === statusConst.TARGET_SUSPENDED) {
            if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
            return self.showErrorModal(messageContent.notifyPendingTransferPhoneNumber);
          } else {
            if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
            return self.showErrorModal(messageContent.requireTry('転送'));
          }
        })
        .catch(err => {
          if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
          self.showErrorModal(messageContent.requireTry('転送'));
        });
      return '';
    },
    handleNumpadClick(conn, digit) {
      conn.sendDigits(digit);
    },
    handleEndCallButtonClick(conn) {
      //console.log('End call!')
      if (this.currentCallInfo.status === 'onhold') {
        this.handleDisconectHoldCall();
        this.handleEndFormSubmit();
        this.updateAgentCallingStatus(false);
        this.$router.go({ path: '/home', force: true });
      } else {
        this.device.disconnectAll();
      }
    },
    handleEndFormSubmit(payload) {
      this.currentCallInfo.status = 'ended';
      this.currentCallInfo.isFullscreen = false;
      this.currentCallInfo = null;
    },
    handleSetCurrentCall() {
      const currentCallInfo = {
        isFullscreen: false,
        microphoneListOptions: this.ringtoneDevices,
        speakerListOptions: this.speakerDevices,
        microphone: this.ringtoneDeviceSelected,
        speaker: this.speakerDeviceSelected,
        handleMicrophoneSelectionChange: this.handleMicrophoneSelectionChange,
        handleSpeakerSelectionChange: this.handleSpeakerSelectionChange,
        status: 'active',
        callingTime: '02:58',
        responseStatusList: [
          {
            label: '着信番号',
            value: '05012345678',
          },
          {
            label: 'プッシュ番号①',
            value: '故障受付',
          },
        ],
        customerInfo: {
          title: '山田 太郎',
          phoneNumber: '080-1234-5678',
          subtitle: '株式会社フォーデジット',
        },
        pendingActiveId: '',
        pendingAvailableList: [
          {
            id: '1',
          },
          {
            id: '2',
          },
          {
            id: '3',
          },
        ],
        memo: this.memo,
        userList: [],
        forwardingUserList: this.forwardingUserList,
        handleCallHistoryButtonClick: this.handleCallHistoryButtonClick,
        handleContactListButtonClick: this.handleContactListButtonClick,
        handleHoldButtonClick: this.handleHoldButtonClick,
        handleTransferCallSubmit: this.handleTransferCallSubmit,
        handleNumpadClick: this.handleNumpadClick,
        handleEndCallButtonClick: this.handleEndCallButtonClick,
        handleEndFormSubmit: this.handleEndFormSubmit,
        handleOnholdActivateButtonClick: this.handleOnholdActivateButtonClick,
        handleOnholdDeactivateButtonClick: this.handleOnholdDeactivateButtonClick,
      };

      this.currentCallInfo = currentCallInfo;
    },
    handleSetCurrentIncomingCall() {
      const currentIncomingCallInfo = {
        customerInfo: {
          title: '山田 太郎',
          phoneNumber: '080-1234-5678',
          subtitle: '株式会社フォーデジット',
        },
        responseStatusList: [
          {
            label: '着信番号',
            value: '05012345678',
          },
          // {
          //   label: 'プッシュ番号①',
          //   value: '故障受付',
          // },
        ],
        hasNewCall: true,
        hasNewOnHold: true,
        onholdList: [
          {
            id: '1',
            active: true,
          },
          {
            id: '2',
            active: true,
          },
          {
            id: '3',
            active: true,
          },
        ],
        handleIncomingCallTabChange: function () {},
        handleRejectCallClick: function () {},
        handleReceiveCallClick: function () {},
        handleOnholdButtonClick: this.handleOnholdButtonClick,
      };
      this.currentIncomingCallInfo = currentIncomingCallInfo;
    },

    //Incoming Call
    handleRejectCallClick(conn) {
      this.outboundProps.conn = null;
      this.isIncomming = false;
      if (this.notificationInstance.incoming) {
        this.notificationInstance.incoming.close();
      }
      this.updateAgentCallingStatus(false);
      conn.reject();
      //console.log("着信拒否しました");
      this.currentIncomingCallInfo = {};
      this.currentIncomingCallInfo.onholdList = this.currentOnHoldList;
    },
    handleReceiveCallClick(conn) {
      conn.accept();
      this.setDirectionUI('inbound');
    },
    handleSyncDocument(token) {
      //Sync
      this.sync = new SyncClient(token);
      // Open a Document by unique name and update its value
      const self = this;
      this.sync
        .document(this.companyID + '_StateDocument')
        .then(function (document) {
          // Listen to updates on the Document
          self.syncDocument = document;
        })
        .catch(function (err) {
          console.log(err);
          //console.log("Could not get document from sync!");
          //console.log("同期不可です");
        });

      this.sync.on('tokenAboutToExpire', function () {
        self.handleRequestToken();
      });

      this.sync
        .map(this.companyID + '_memoSync')
        .then(function (map) {
          self.memoSyncMap = map;
          map.on('itemUpdated', function (event) {
            self.memoSyncItemUpdatedHandler(event);
          });

          map.on('itemAdded', function (event) {
            self.memoSyncItemUpdatedHandler(event);
          });
        })
        .catch(function (error) {});

      // Twilio Syncのrate limitが低い（20 updates/s）のためコメントアウトする
      // this.sync
      //   .document(this.companyID + '_onlineStateDocument')
      //   .then(function (document) {
      //     // Listen to updates on the Document
      //     self.syncDocument = document;
      //     //First time update
      //     self.onlineStatuses = document.data;
      //     //Listen update event
      //     document.on('updated', function (event) {
      //       self.onlineStatuses = event.data;
      //       console.log('Status updated');
      //       console.log(self.onlineStatuses);
      //     });
      //   })
      //   .catch(function (err) {
      //     console.log(err);
      //   });
    },
    memoSyncItemUpdatedHandler(event) {
      const syncData = event.item.data;
      if (syncData && syncData[this.clientName] && this.currentCallInfo) {
        this.currentCallInfo.memoUpdated = true;
      }
    },
    syncMapItemUpdateHandler(event) {
      const item = event.item;
      const callsid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      if (item.key === callsid && item && item.data) {
        //if is calling sid, update new data
        const updateData = item.data;
        if (updateData.event === 'transfer') {
          if (this.currentCallInfo && this.currentCallInfo.customerInfo) {
            const phoneNumber = updateData.toName ? updateData.toName : updateData.phoneNumber;
            this.currentCallInfo.customerInfo = {
              phoneNumber: phoneNumber,
              title: updateData.toName ? updateData.toName : '',
            };
            this.currentCallInfo.responseStatusList = [{ label: '発信番号', value: phoneNumber }];
          }
          this.customerInfo.phoneNumber = updateData.to;
          this.customerInfo.rawPhoneNumber = updateData.to;
          this.currentCallInfo.isHoldCountExceeded = updateData.isReachHoldCountLimit;
          this.currentCallInfo.isTransferCountExceeded = updateData.isReachTransferCountLimit;
        } else if (updateData.event === 'hold') {
          this.currentCallInfo.isHoldCountExceeded = updateData.isReachHoldCountLimit;
          this.currentCallInfo.isTransferCountExceeded = updateData.isReachTransferCountLimit;
        }
      }
    },
    //Firebase realtime
    unsubscriberParkHold() {
      const self = this;
      const parkHold1Unsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/parkhold/park_1`,
        function (data) {
          self.updateParkQueue('park_1', data);
        }
      );
      const parkHold2Unsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/parkhold/park_2`,
        function (data) {
          self.updateParkQueue('park_2', data);
        }
      );
      const parkHold3Unsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/parkhold/park_3`,
        function (data) {
          self.updateParkQueue('park_3', data);
        }
      );
    },
    unsubscriberHold() {
      const self = this;
      const holdUnsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/callEvent/hold`,
        function (data) {
          self.updateHold(data);
        }
      );
    },
    unsubscriberTransfer() {
      const self = this;
      const transferUnsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/callEvent/transfer`,
        function (data) {
          self.updateTransfer(data);
        }
      );
    },
    updateHold(data) {
      if (!data) return;
      const callSid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      if (data.callSid !== callSid) return;

      this.currentCallInfo.isHoldCountExceeded = data.isReachHoldCountLimit;
      this.currentCallInfo.isTransferCountExceeded = data.isReachTransferCountLimit;
    },
    updateTransfer(data) {
      if (!data) return;
      const callSid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      if (data.callSid !== callSid) return;

      if (this.currentCallInfo && this.currentCallInfo.customerInfo) {
        const phoneNumber = data.toName ? data.toName : data.phoneNumber;
        this.currentCallInfo.customerInfo = {
          phoneNumber: phoneNumber,
          title: data.toName ? data.toName : '',
        };
        this.currentCallInfo.responseStatusList = [{ label: '発信番号', value: phoneNumber }];
      }
      this.customerInfo.phoneNumber = data.to;
      this.customerInfo.rawPhoneNumber = data.to;
      this.currentCallInfo.isHoldCountExceeded = data.isReachHoldCountLimit;
      this.currentCallInfo.isTransferCountExceeded = data.isReachTransferCountLimit;
    },
    //Syncからのパーク情報を更新
    updateParkQueue(parkId, data) {
      const onholdList = this.currentOnHoldList;
      const pendingAvailableList = this.currentPendingAvailableList;
      const checkId = parkId;
      const park = {
        id: checkId,
        active: false,
        callSid: '',
        partnerCallSid: '',
        directionFlg: '',
        customerPhoneNumber: '',
        customerRawPhoneNumber: '',
        customerTitle: '',
        resumedClient: '',
        heldClient: '',
        pushNumberSettingName: '',
        telNumberInfo: null,
        isReachHoldCountLimit: false,
        isReachTransferCountLimit: false,
      };
      if (data) {
        park.active = data.active;
        park.callSid = data.callSid;
        park.partnerCallSid = data.partnerCallSid;
        park.directionFlg = data.directionFlg;
        park.customerPhoneNumber = data.customerPhoneNumber;
        park.customerRawPhoneNumber = data.customerRawPhoneNumber;
        park.customerTitle = data.customerTitle;
        park.resumedClient = data.resumedClient;
        park.resumedTitle = data.resumedTitle;
        park.heldClient = data.heldClient;
        park.pushNumberSettingName = data.pushNumberSettingName;
        park.telNumberInfo = data.telNumberInfo;
        park.isReachHoldCountLimit = data.isReachHoldCountLimit;
        park.isReachTransferCountLimit = data.isReachTransferCountLimit;
        //通話中保留可能一覧
        // if(!park.active || (this.currentCallInfo && this.currentCallInfo.pendingActiveId === checkId)) {//False = 使用なし
        //   pendingAvailableList.push({ id: checkId });
        // }
        if (park.active && this.clientName === this.getClientName(park.customerRawPhoneNumber)) {
          this.currentParkQueue = checkId;
          if (typeof park.isReachHoldCountLimit !== 'undefined' && this.currentCallInfo) {
            this.currentCallInfo.isHoldCountExceeded = park.isReachHoldCountLimit;
          }
          if (typeof park.isReachTransferCountLimit !== 'undefined' && this.currentCallInfo) {
            this.currentCallInfo.isTransferCountExceeded = park.isReachTransferCountLimit;
          }
        }
        if (
          this.currentParkQueue === checkId &&
          this.clientName === this.getClientName(park.customerRawPhoneNumber) &&
          park.resumedClient
        ) {
          this.customerInfo.rawPhoneNumber = park.resumedClient;
          this.currentCallInfo.customerInfo.title = park.resumedTitle;
          this.customerInfo.title = park.resumedTitle;
        }
      } else {
        //pendingAvailableList.push({ id: checkId });
      }
      //Push if not exist or when initial list
      const pendingAvailableIndex = pendingAvailableList.findIndex(park => park.id === checkId);
      if (pendingAvailableIndex !== -1) {
        pendingAvailableList[pendingAvailableIndex] = { id: checkId, status: park.active };
      } else {
        pendingAvailableList.push({ id: checkId, status: park.active });
      }
      //pendingAvailableList.push({ id: checkId, status: park.active });
      const onHoldIndex = onholdList.findIndex(park => park.id === checkId);
      if (onHoldIndex !== -1) {
        onholdList[onHoldIndex] = park;
      } else {
        onholdList.push(park);
      }
      const onholdNotificationList = [];
      for (let idx = 0; idx < onholdList.length; ++idx) {
        if (onholdList[idx].active === true) {
          onholdNotificationList.push({
            id: onholdList[idx].id,
            idNumber: onholdList[idx].id.slice(-1),
            pushNumberSettingName: onholdList[idx].pushNumberSettingName,
            telNumberInfo: onholdList[idx].telNumberInfo,
          });
        }
      }

      const self = this;
      for (let idx = 0; idx < onholdNotificationList.length; ++idx) {
        this.checkNotificationPermission()
          .then(result => {
            if (result === 'granted') {
              if (this.notificationFlag === true) {
                const pbSettingName = self.collapseText(onholdNotificationList[idx].pushNumberSettingName, 10);
                const pbSettingNameMessage = pbSettingName ? `プッシュ番号設定名称：${pbSettingName}\n` : ``;
                // TODO number name
                const telNumberInfo = onholdNotificationList[idx].telNumberInfo;
                const telNumberMsg = telNumberInfo
                  ? `\n番号名称：${self.collapseText(telNumberInfo.numberName || '未設定', 10)}　自番号：${
                      telNumberInfo.telNumber
                    }`
                  : '';
                this.notificationInstance.onhold[onholdNotificationList[idx].id] = new Notification(
                  'COTOHA Call Center',
                  {
                    body:
                      pbSettingNameMessage +
                      '取次保留' +
                      onholdNotificationList[idx].idNumber +
                      'が来ています。' +
                      telNumberMsg,
                    icon: '',
                    tag: '',
                    data: {},
                  }
                );
                this.notificationInstance.onhold[onholdNotificationList[idx].id].onclick = event => {
                  event.preventDefault();
                  window.focus();
                  this.notificationInstance.onhold[onholdNotificationList[idx].id].close();
                };
              }
            }
          })
          .catch(err => {
            console.error(err);
          });
      }

      //console.log("onholdList");
      //console.log(onholdList);
      //着信保留一覧
      this.currentOnHoldList = onholdList;
      //通話中保留一覧
      if (this.currentCallInfo) {
        this.currentCallInfo.pendingAvailableList = pendingAvailableList;
      }
      this.currentPendingAvailableList = pendingAvailableList;
      this.handleSettingIncomingCallInfo();
    },

    handleOnholdActivateButtonClick(itemId) {
      this.handleSetOnholdButton(itemId);
    },
    handleOnholdDeactivateButtonClick(itemId) {
      this.handleOnholdButtonClick(itemId);
    },
    /**
     * 電話中からパーク保留を登録
     */
    handleSetOnholdButton(parkId) {
      if (this.currentCallInfo) this.currentCallInfo.isLoading = true;
      const callSid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      const queueName = `${this.companyID}_${parkId}`;
      const self = this;
      self.currentCallInfo.status = 'parkhold';
      self.currentCallInfo.pendingActiveId = parkId;
      const pushNumberSettingName = self.currentCallInfo.pushNumberSettingName ?? '';
      const telNumberInfo = self.currentCallInfo.telNumberInfo;
      this.postRequest('/parkHold', {
        CallSid: callSid,
        QueueName: queueName,
        Direction: this.directionFlg,
        clientName: this.clientName,
        fromClient: self.customerInfo.rawPhoneNumber,
      }).then(data => {
        if (data.status === 'success') {
          //他のオペレーターに共有のため、通話中の情報をSyncドキュメントに保存
          const updateData = {
            active: true, //パークを格納されるかのステータス
            callSid: callSid, //通話中のCallSid
            partnerCallSid: data.partnerCallSid,
            directionFlg: self.directionFlg, //着信か発信のフラグ
            customerPhoneNumber: self.customerInfo.phoneNumber,
            customerRawPhoneNumber: self.customerInfo.rawPhoneNumber,
            heldClient: `client:${self.companyID}-${self.clientName}`,
            customerTitle: self.customerInfo.title,
            pushNumberSettingName,
            telNumberInfo,
            isReachHoldCountLimit: data.isHoldLimit,
            isReachTransferCountLimit: data.isTransferLimit,
            ownNumber: telNumberInfo ? telNumberInfo.telNumber : self.currentUserInfo.phone_number,
            holdCount: data.holdCount,
            transferCount: data.transferCount,
          };
          this.postRequest('/parkHold/sync-park-data', { parkID: parkId, data: updateData }); //Syncドキュメントに保存
        } else if (data.status === statusConst.EXCEED_HOLD_COUNT_LIMIT) {
          self.currentCallInfo.status = 'holdexceed';
          self.currentCallInfo.isHoldCountExceeded = true;
          if (self.currentCallInfo) self.currentCallInfo.isLoading = false;
          self.showErrorModal(messageContent.exceedHoldCountLimit);
        } else {
          if (self.currentCallInfo) {
            self.currentCallInfo.isLoading = false;
            self.currentCallInfo.status = 'active';
            self.currentCallInfo.pendingActiveId = '';
          }
          //コールが保留中
          if (data.status === 'callIsHolding') {
            self.showErrorModal(messageContent.callIsHolding);
          } else if (data.status === 'parkHoldIsUsing') {
            //このパーク保留が使用中
            self.showErrorModal(messageContent.parkHoldIsUsing);
          } else if (data.status === 'updateCallFailed') {
            self.hasError = true;
            self.showErrorModal(messageContent.notifyCalledDisconnected);
          } else {
            //他のエラー
            self.hasError = true;
            self.showErrorModal(messageContent.requireTry('保留'));
          }
        }
      });
    },
    /**
     * パーク保留取得
     */
    handleOnholdButtonClick: async function (parkId) {
      const queueName = `${this.companyID}_${parkId}`;
      this.directionFlg = 'outbound-dial';
      const customerInfo = {};

      const holdItem = this.getPark(`${parkId}`);
      if (!holdItem) {
        this.showErrorModal('パーク保留が見つかりません。');
        return;
      }
      const checkQueue = await this.handleGetQueueInfo(queueName);
      if (!checkQueue || checkQueue.currentMember === 0) {
        //保留中の発信元が切断
        this.showErrorModal(messageContent.notifyCalledDisconnected);
        const updateData = {};
        updateData[`${parkId}`] = {
          active: false,
        };
        this.postRequest('/parkHold/sync-park-data', { parkID: parkId, data: { active: false } });
        return;
      }
      const params = {
        To: queueName,
        From: this.formatSelectedCurrentNumber,
        Type: 'resume',
        DirectionFlg: this.directionFlg,
        CallerNumber: this.formatSelectedCurrentNumber,
        ParkId: parkId,
        CustomerPhoneNumber: holdItem.customerPhoneNumber,
        CustomerRawPhoneNumber: holdItem.customerRawPhoneNumber,
        CustomerTitle: holdItem.customerTitle,
        heldClient: holdItem.heldClient,
        companyID: this.companyID,
        userID: this.userID,
        pushNumberSettingName: holdItem.pushNumberSettingName,
        Called: holdItem.telNumberInfo ? holdItem.telNumberInfo.telNumber : '',
      };

      //発信桁数チェック(nullの場合は発信不可とする)
      if (params.To === null) {
        //console.log('宛先が空です。');
        return;
      }

      //console.log('Calling ' + params.To + '...');
      if (this.device) {
        const outgoingConnection = await this.device.connect({ params });
        if (holdItem.directionFlg) this.directionFlg = holdItem.directionFlg;
        const self = this;

        outgoingConnection.on('accept', async function (conn) {
          //Fix #2297:同時にパークした時の対処をする
          await self.handleDeleteQueue(queueName);
          const callSid = conn.parameters.CallSid;
          self.setCookie('CallSid', callSid);
          self.currentCallSid = callSid;
          const updateData = {
            active: false,
            callSid: callSid,
            partnerCallSid: holdItem.partnerCallSid,
            directionFlg: holdItem.directionFlg,
            customerPhoneNumber: holdItem.customerPhoneNumber,
            customerRawPhoneNumber: holdItem.customerRawPhoneNumber,
            customerTitle: holdItem.customerTitle,
            resumedClient: `client:${self.companyID}-${self.clientName}`,
            resumedTitle: self.agentName, // 取得したagent name
          };
          self.customerInfo.title = holdItem.customerTitle;
          self.customerInfo.phoneNumber = holdItem.customerPhoneNumber;
          self.customerInfo.rawPhoneNumber = holdItem.customerRawPhoneNumber;
          self.postRequest('/parkHold/sync-park-data', { parkID: parkId, data: updateData });
          self.limitCountData = {
            isReachHoldCountLimit: holdItem.isReachHoldCountLimit,
            isReachTransferCountLimit: holdItem.isReachTransferCountLimit,
          };
          // update partnerCallSid
          self
            .postRequest('/parkHold/updatePartnerCallSid', { partnerCallSid: holdItem.partnerCallSid })
            .then(res => {
              if (res.status === 'success') {
                console.log('Update partnerCallSid successfully!');
              } else {
                console.log('Update partnerCallSid failed!');
              }
            })
            .catch(e => {
              console.error(e);
            });
          self.handleAcceptIncomingCall(conn);
        });

        outgoingConnection.on('disconnect', function (conn) {
          self.handleDisconnectCall(conn);
        });
      }
    },
    getCookie(key) {
      const name = key + '=';
      const cookie = document.cookie;
      const cookieList = cookie.split(';');
      for (let i = 0; i < cookieList.length; i++) {
        let cookieItem = cookieList[i];
        while (cookieItem.charAt(0) === ' ') {
          cookieItem = cookieItem.substring(1);
        }
        if (cookieItem.indexOf(name) === 0) {
          return cookieItem.substring(name.length, cookieItem.length);
        }
      }
      return '';
    },
    setCookie(key, value, expires = null) {
      if (!expires) {
        const d = new Date();
        // Cookie expires after 3 days
        d.setTime(d.getTime() + 3 * 24 * 60 * 60 * 1000);
        expires = 'expires=' + d.toUTCString();
      }
      document.cookie = `${key}=${value};expires=${expires}`;
    },
    formatCallerNumber(fromNumber, conn) {
      if (!fromNumber) {
        return '';
      } else if (WITHHELD_NUMBERS.includes(fromNumber)) {
        fromNumber = WITHHELD_NUMBER_ALIAS;
      } else {
        if (
          fromNumber.toString().match(/^\+81/) !== null ||
          fromNumber.includes('client') ||
          fromNumber.length === 36 ||
          fromNumber.length === 43 ||
          fromNumber.length === 46
        ) {
          //companyID(6) -(1) id(36)
          fromNumber = this.formatCallerId(fromNumber, conn);
        }
      }

      return fromNumber;
    },
    formatCallerId: function (callerId, conn) {
      if (callerId.toString().match(/^\+81/) !== null) {
        //電話番号は+81を0に変換
        return (callerId = '0' + callerId.slice(3));
      } else if (callerId.slice(0, 1) === '0' && callerId.length <= 12) {
        //普通電話番号
        return callerId;
      } else {
        //cliantIdはclient:を除去してagentNameを取得
        if (conn && conn.customParameters.get('agentName')) {
          callerId = conn.customParameters.get('agentName');
        } else {
          let formatCallerId = callerId.replace('client:', '');
          formatCallerId = formatCallerId.slice(-36);
          const tmpList = this.clientList.filter(client => client.value === formatCallerId);
          if (tmpList.length > 0) {
            callerId = tmpList[0].label;
          } else {
            callerId = '';
          }
        }
      }
      return callerId;
    },
    formatSysTemCallNumber(phoneNumber) {
      if (!phoneNumber) return null;
      return '+81' + phoneNumber.slice(1);
    },
    bindVolumeIndicators(connection) {
      const self = this;
      connection.on('volume', function (inputVolume, outputVolume) {});
    },
    updateAllDevices: async function () {
      this.speakerDevices = await this.updateDevices(
        'speakerDeviceSelected',
        this.speakerDevices,
        this.device.audio.speakerDevices.get()
      );
      this.ringtoneDevices = await this.updateDevices(
        'ringtoneDeviceSelected',
        this.ringtoneDevices,
        this.device.audio.ringtoneDevices.get()
      );
      this.inputDevices = await this.updateInputDevices(
        'inputDeviceSelected',
        this.inputDevices,
        this.device.audio.inputDevice
      );
      if (this.currentCallInfo) {
        this.currentCallInfo.speakerListOptions = this.speakerDevices;
        this.currentCallInfo.microphoneListOptions = this.inputDevices;
        this.currentCallInfo.microphone = this.inputDeviceSelected;
        this.currentCallInfo.speaker = this.speakerDeviceSelected;
      }
    },
    //Update the available input devices
    updateInputDevices(selectedEl, selectedList, selectedDevices) {
      this[selectedEl] = '';
      selectedList = [];
      let microphone_exist = false;
      let microphone_default_label;
      const currentMicrophone = localStorage.getItem('microphoneId');
      const microphones_size = this.device.audio.availableInputDevices.size;
      const self = this;
      if (microphones_size !== 0) {
        this.device.audio.availableInputDevices.forEach(function (device, id) {
          const option = {};
          option.label = device.label;
          option.value = id;
          selectedList.push(option);
          if (selectedEl === 'inputDeviceSelected' && id === currentMicrophone) {
            microphone_exist = true;
            self[selectedEl] = id;
          } else if (selectedEl === 'inputDeviceSelected' && id === DEFAULT_DEVICE) {
            microphone_default_label = device.label;
          }
        });
      }

      if (microphone_exist === false && microphone_default_label) {
        localStorage.setItem('microphoneId', DEFAULT_DEVICE);
        localStorage.setItem('microphoneName', microphone_default_label.replace(/\(....:....\)/, ''));
        if (selectedList && selectedList.length > 0 && !this[selectedEl]) {
          this[selectedEl] = selectedList[0].value;
        }
      }
      return selectedList;
    },
    // Update the available ringtone and speaker devices
    updateDevices: async function (selectedEl, selectedList, selectedDevices) {
      this[selectedEl] = '';
      selectedList = [];
      const self = this;
      let speaker_exist = false;
      let speaker_default_label;
      const currentSpeaker = localStorage.getItem('speakerId');
      const speakers_size = this.device.audio.availableOutputDevices.size;
      if (speakers_size !== 0) {
        this.device.audio.availableOutputDevices.forEach(function (device, id) {
          let isActive = selectedDevices.size === 0 && id === DEFAULT_DEVICE;
          selectedDevices.forEach(function (device) {
            if (device.deviceId === id) {
              isActive = true;
            }
          });

          const option = {};
          option.label = device.label;
          option.value = id;
          if (isActive) {
            self[selectedEl] = id;
          }
          selectedList.push(option);
          if (selectedEl === 'speakerDeviceSelected' && id === currentSpeaker) {
            speaker_exist = true;
          } else if (selectedEl === 'speakerDeviceSelected' && id === DEFAULT_DEVICE) {
            speaker_default_label = device.label;
          }
        });
      }
      console.debug('最初から、updateDevices: ');
      console.debug(`before change localStorage updateDevices ${selectedEl} : ${localStorage.getItem('speakerId')}`);
      console.debug(`before change Twilio updateDevices ${selectedEl} :`);
      console.debug(await this.device.audio.speakerDevices.get());
      if (speaker_exist === false && speaker_default_label) {
        localStorage.setItem('speakerId', DEFAULT_DEVICE);
        localStorage.setItem('speakerName', speaker_default_label.replace(/\(....:....\)/, ''));
      } else {
        if (this.device) {
          try {
            await this.device.audio.speakerDevices.set(currentSpeaker);
            await this.device.audio.ringtoneDevices.set(currentSpeaker);
          } catch (e) {
            console.log(e);
          }
        }
      }
      console.debug(`after localStorage updateDevices ${selectedEl} : ${localStorage.getItem('speakerId')}`);
      console.debug(`after Twilio updateDevices ${selectedEl} :`);
      console.debug(await this.device.audio.speakerDevices.get());
      return selectedList;
    },
    setDirectionUI(direction) {
      this.directionFlg = direction;
    },
    handleAudio: async function () {
      const speakerId = localStorage.getItem('speakerId');
      const microphoneId = localStorage.getItem('microphoneId');
      console.debug('current speakerId (localStorage): ', speakerId);
      console.debug('current microphoneId (localStorage): ', microphoneId);
      const availableSpeakerDevices = this.device.audio.availableOutputDevices;
      const speakers_size = availableSpeakerDevices.size;
      const availableInputpeakerDevices = this.device.audio.availableInputDevices;
      const microphones_size = availableInputpeakerDevices.size;
      if (speakers_size === 0) {
        this.showErrorModal(this.notSetItem('スピーカー'));
        return false;
      }
      if (microphones_size === 0) {
        this.showErrorModal(this.notSetItem('マイク'));
        return false;
      }
      if (speakerId) {
        try {
          await this.handleSpeakerSelectionChange(speakerId);
        } catch (e) {
          console.info(e);
          await this.handleSpeakerSelectionChange(DEFAULT_DEVICE);
        }
      }
      // if (microphoneId) {
      //   await this.handleMicrophoneSelectionChange(microphoneId);
      // }
      return true;
    },
    async handleCall(to, from) {
      if (this.isIncomming) {
        this.showErrorModal('着信中や通話中に発信できません。');
        return;
      }
      if (this.device.state === Device.State.Unregistered) {
        this.showErrorModal(messageContent.notifyTwilioDeviceNotReadyWarning);
        return;
      }
      if (to && chkTrialCompanyID(this.companyID)) {
        this.showErrorModal(messageContent.notifyTrialUserCanNotMakeGaiSenCall());
        return;
      }
      this.isbuttonCall = 'on';
      if (!to && (!this.selectedCurrentClient || !this.selectedCurrentClient.value)) {
        this.showErrorModal(messageContent.requireInput('電話番号か、オペレーター'));
        return;
      }
      if (to && to.currentPhoneNumber && !this.numberOnly(to.currentPhoneNumber)) {
        this.showErrorModal(messageContent.requireInputFormat('電話番号を英数字'));
        return;
      }

      // Contract status check
      let constractStatus, trialStatus;
      await this.postRequest('/contract/status-check')
        .then(res => {
          if (res.status === 'success') {
            trialStatus = res.data.trialStatus;
            constractStatus = res.data.contractStatus;
          } else {
            throw messageContent.requireTry('契約情報確認');
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('契約情報確認'));
        });
      // 契約情報確認中にエラーが発生しました。
      if (!constractStatus && !trialStatus) return;
      // If contract is closing, stop the call
      if (constractStatus === 'close') {
        this.showErrorModal(messageContent.requireMakeCall('解約済'));
        return;
      }
      // 移行期間中の場合通話できない
      if (this.isTrial && trialStatus === 'transiting') {
        this.showErrorModal(messageContent.requireMakeCall('移行期間中'));
        return;
      }

      console.debug('handleAudio start');
      const handleAudioResult = await this.handleAudio();
      //スピーカーとマイクロフォン設定
      if (!handleAudioResult) return;
      console.debug('handleAudio end');

      const phoneNumber = to ? to.currentPhoneNumber : '';

      const params = {
        //テキストに入力された番号がToへ
        To: phoneNumber,
        From: this.formatSysTemCallNumber(from),
        CallerNumber: this.formatSelectedCurrentNumber,
        ClientName: this.clientName,
        companyID: this.companyID,
        userID: this.userID,
      };
      //発信中画面
      this.isCalling = true;

      //発信桁数チェック(空欄の場合は内線とする)
      let extensionFlg = false;
      if (params.To === '') {
        //発信先が通話可能かチェック
        const result = await this.postRequest('/clientUpdate/getinfo', { clientName: this.selectedCurrentClient.value })
          .then(data => {
            if (data.status === 'success') return data.data.callingStatus;
            return true;
          })
          .catch(e => {
            return true;
          });
        if (result) {
          this.device.audio.unsetInputDevice();
          this.isCalling = false;
          this.showErrorModal(messageContent.notifyCalledBusy('発信先'));
          return;
        }
        params.To = `${this.companyID}-${this.selectedCurrentClient.value}`;
        params.From = `client:${this.companyID}-${this.clientName}`;
        params.AgentName = this.agentName; //オペレーター名
        extensionFlg = true;
      }
      if (this.device) {
        //外線の場合はデフォルトで050発信をできるようにする,050を+81に置換
        if (extensionFlg === false) {
          const top = params.To.slice(0, 1);
          if (top === '0') {
            params.To = '+81' + params.To.slice(1);
          }
        }
        const customerInfo = {
          phoneNumber: params.To,
          rawPhoneNumber: params.To,
          title: to && to.title ? to.title : this.formatCallerNumber(params.To),
        };
        this.customerInfo = customerInfo;
        const outgoingConnection = await this.device.connect({ params });
        const self = this;
        //Outgoing Modal
        this.handleHangUpClick = function (outgoingConnection) {
          self.device.disconnectAll();
          self.isCalling = false;
        };

        outgoingConnection.on('ringing', function (hasEarlyMedia) {
          self.updateAgentCallingStatus(true);
          self.setDirectionUI('outbound-dial');
          if (!phoneNumber) {
            //内線場合、音声ファイルを指定

            //Wait 2sec for ringbacktone;
            setTimeout(() => {
              if (self.ringingBackTone) self.ringingBackTone.play();
            }, 1000);
          }
          // 時々CallSidは不正です。TJSのタイプの場合は相手から切断したが発信画面はそのまま変わらない
          // そのため2秒ごとにコールが切断したかチェックを行う
          // ringback toneがある場合、ringingイベントは２回発生し、複数interval生成しないようにsetIntervalを呼ぶ前にclearIntervalを行う
          if (self.callAliveCheckInterval) clearInterval(self.callAliveCheckInterval);
          self.callAliveCheckInterval = setInterval(self.checkCallAlive, 2000);
        });

        //通話開始イベント
        outgoingConnection.on('accept', function (conn) {
          // 通話開始済なので終話チェックはいらない
          if (self.callAliveCheckInterval) clearInterval(self.callAliveCheckInterval);

          if (self.ringingBackTone) self.ringingBackTone.pause();
          self.handleAcceptIncomingCall(conn);
        });

        //通話終了イベント
        outgoingConnection.on('disconnect', async function (conn) {
          // 終話済なので終話チェックはいらない
          if (self.callAliveCheckInterval) clearInterval(self.callAliveCheckInterval);

          //発信終了イベントとDeviceの通話終了イベントが重複になっているので、
          //通話開始する前場合、終了の場合、こちらでステータス更新する、
          //通話開始した後場合、終了の場合、Device.on('disconnect')イベントでステータス更新する
          if (!self.currentCallInfo) self.updateAgentCallingStatus(false);
          if (self.ringingBackTone) self.ringingBackTone.pause();
          self.isCalling = false;
          if (!conn.parameters || !self.checkIsValidCallSid(conn.parameters.CallSid)) {
            await self.postRequest('/clientUpdate/disconnectcurrentcall').then(data => {
              if (data.status !== 'success') {
                console.debug('Can not disconnect the current call.');
              } else {
                console.debug('The current call is disconnected.');
              }
            });
          }
          self.handleDisconnectCall(conn);
        });

        //通話エラー、Rejectイベント
        outgoingConnection.on('error', function (error) {
          console.info(error);
          if (self.ringingBackTone) self.ringingBackTone.pause();
          self.isCalling = false;
          if (error.code === 31005) return; ////reject by client、HANGUP error code
          self.device.disconnectAll();
        });
      }
    },
    checkIsValidCallSid(callSid) {
      if (!callSid) return false;

      return callSid.startsWith('CA');
    },
    checkCallAlive() {
      const self = this;
      this.postRequest('/clientUpdate/getcurrentcallinfo').then(data => {
        if (data.status === 'success') {
          if (!data.isAlive) {
            console.debug('Update UI due to call is disconnected.');
            clearInterval(self.callAliveCheckInterval);
            self.device.disconnectAll();
            self.isCalling = false;
          }
        } else {
          clearInterval(self.callAliveCheckInterval);
        }
      });
    },
    handleNumberChange(selectedClient) {
      this.selectedCurrentClient = selectedClient;
    },
    handleClientListChange(clientList) {
      this.clientList = clientList;
    },
    updateAgentStatus: function (agentStatus) {
      const self = this;
      this.postRequest('/clientUpdate', { agentStatus }).then(data => {
        if (data.status === 'success') {
          self.updateOnlineStatus(agentStatus);
        }
      });
    },
    //通話中のステータスを更新（通話中：true)
    updateAgentCallingStatus(callingStatus, currentCallSid) {
      this.postRequest('/clientUpdate', { callingStatus, currentCallSid });
    },
    checkNewHold(holdList) {
      if (holdList && holdList.length > 0) {
        const newHold = holdList.find(hold => hold.active === true);
        if (newHold) return true;
        try {
          for (const key in this.notificationInstance.onhold) {
            if (this.notificationInstance.onhold[key]) {
              this.notificationInstance.onhold[key].close();
            }
          }
        } catch (err) {
          console.error(err);
        }
        return false;
      }
      return false;
    },
    getPark(parkId) {
      return this.currentOnHoldList.find(park => park.id === parkId);
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    handleDisconectHoldCall() {
      const callsid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      const self = this;
      this.postRequest('/hold/disconnectcall', {
        callSid: callsid,
        directionFlg: this.directionFlg,
        clientName: this.clientName,
      })
        .then(e => {
          self.setCallEnd();
        })
        .catch(() => {
          self.showErrorModal(messageContent.requireTry('切断'));
        });
    },
    setCallEnd() {
      if (this.currentCallInfo) {
        this.currentCallInfo.status = 'ended';
        this.currentCallInfo = null;
      }
      this.updateAgentCallingStatus(false);
      this.handleSettingIncomingCallInfo(null);
    },
    handleGetQueueInfo(callSid) {
      return this.postRequest('/hold/checkQueue', { callSid: callSid })
        .then(data => {
          if (data.status === 'success') return data.data;
          return null;
        })
        .catch(e => {
          return null;
        });
    },
    handleDeleteQueue(queueName) {
      return this.postRequest('/parkHold/removeParkHold', { queueName: queueName })
        .then(data => {
          if (data.status === 'success') return true;
          return false;
        })
        .catch(e => {
          return false;
        });
    },
    getClientName(client) {
      if (!client || client.length < 36) return null;
      // Client is clientname
      if (client.length === 36) return client.replace(/_/g, '-');
      // Client format: "client:companyID-clientName"
      return client.replace('client:', '').slice(-36).replace(/_/g, '-');
    },
    handleGetClientList: async function () {
      const self = this;
      await this.postRequest('/getClientList').then(data => {
        self.clientList = data.data;
        //クライアント一覧から、ログインしているクライアントIDを抜く
        self.clientList = self.clientList.filter(client => client.id !== self.clientName);
        self.clientList = self.clientList.map(item => {
          const obj = {};
          obj.value = item.id;
          obj.label = item.name ? item.name.replace(/_|＿/g, ' ') : '';
          obj.status = USER_STATUSES.OFFLINE;
          return obj;
        });
        self.updateClientList();
        if (self.currentCallInfo) {
          let cList = cloneDeep(self.forwardingUserList);
          const rawPhoneNumber = self.currentCallInfo.customerInfo.rawPhoneNumber;
          const partnerClientName = self.getClientName(rawPhoneNumber);
          // 内線通話中の場合は、通話相手を除外する(#5103)
          if (partnerClientName) {
            cList = cList.filter(client => client.value !== partnerClientName);
          }
          self.currentCallInfo.forwardingUserList = cList;
        }
      });
    },
    checkNotificationPermission: async function () {
      let permissionResult = '';
      await Notification.requestPermission()
        .then(permission => {
          if (permission === 'granted') {
            permissionResult = 'granted';
          } else if (permission === 'denied') {
            permissionResult = 'denied';
          } else if (permission === 'default') {
            permissionResult = 'default';
          } else {
            permissionResult = null;
          }
        })
        .catch(err => {
          console.error('Notification requestPermission error ' + err);
          permissionResult = null;
        });
      return permissionResult;
    },
    updateFullscreenState(flag) {
      this.callingModalFullscreen = flag;
    },
    updateMemoEmptyStatus(flag) {
      this.callingModalMemoEmpty = flag;
    },
    syncMemo(syncData) {
      const callsid = this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid;
      if (syncData) {
        this.memoSyncMap.set(callsid, syncData, { ttl: 60 });
      }
    },
    handleAcceptIncomingCall: async function (call) {
      await this.postRequest('/callSidUpdate', {
        clientName: this.clientName,
        companyID: this.companyID,
        userID: this.userID,
        callSid: call.parameters.CallSid,
        extTo: call.parameters.To,
        partnerClient: call.customParameters.get('CustomerRawPhoneNumber'),
        type: call.customParameters.get('Type'),
        fromClient: call.customParameters.get('fromClient'),
        from: call.parameters.From,
        heldClient: call.customParameters.get('heldClient'),
        callingStatus: true, //通話中の時、trueになる
        direction: this.directionFlg,
      }).catch(err => {
        //console.log(err);
      });
      this.isIncomming = true;
      //Outgoing Modal
      if (this.ringingBackTone) this.ringingBackTone.pause();

      const microphoneId = localStorage.getItem('microphoneId');
      if (microphoneId) {
        try {
          await this.handleMicrophoneSelectionChange(microphoneId);
        } catch (e) {
          console.info(e);
          try {
            await this.handleMicrophoneSelectionChange(DEFAULT_DEVICE);
          } catch (e) {
            console.log(e);
          }
        }
      }

      const speakerId = localStorage.getItem('speakerId');
      if (speakerId) {
        try {
          await this.handleSpeakerSelectionChange(speakerId);
        } catch (e) {
          console.info(e);
          try {
            await this.handleSpeakerSelectionChange(DEFAULT_DEVICE);
          } catch (e) {
            console.log(e);
          }
        }
      }
      this.handleHangUpClick = function () {};
      this.isCalling = false;
      this.handleSettingCurentCallInfo(call);
      this.currentIncomingCallInfo = {};
      if (this.notificationInstance.incoming) {
        this.notificationInstance.incoming.close();
      }
      console.debug(this.device.audio.speakerDevices.get());
      console.debug(this.device.audio.inputDevice);

      // Salesforce連携がONであればケース作成
      if (this.sfAvailable === true) {
        const sendingCurrentCallInfo = {
          customerInfo: {
            phoneNumber: this.currentCallInfo.customerInfo.phoneNumber
              ? this.currentCallInfo.customerInfo.phoneNumber
              : '',
          },
        };
        await this.postRequest('/callLogClient/createSfCase', {
          CallSid: this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid,
          callInfo: sendingCurrentCallInfo,
          direction: this.directionFlg,
          isExtensionCallOutbound: !this.currentCallInfo.isTransferOk,
          pageUrl: window.location.href,
          agentName: this.agentName,
          missedFlag: false,
        })
          .then(e => {
            if (e.status === 'success') {
              this.currentCallInfo.createdCaseId = e.data.createdCaseId;
              this.createdCaseId = e.data.createdCaseId;
            }
          })
          .catch(err => {
            console.error(err);
          });
      }
    },
    handleDisconnectCall: async function (call) {
      this.isIncomming = false;
      if (this.notificationInstance.incoming) {
        this.notificationInstance.incoming.close();
      }
      if (this.currentCallInfo) this.currentCallInfo.isLoading = false;
      if (this.currentCallInfo) {
        //if(this.currentCallInfo.status === 'onhold') {} else {
        if (
          this.currentCallInfo.status === 'transfer' ||
          this.currentCallInfo.status === 'transfering' ||
          this.currentCallInfo.status === 'parkhold'
        ) {
          this.currentCallInfo.status = 'active';
        }
        if (this.currentCallInfo.status === 'active') {
          // ソフトフォンが最小化かつメモが空の場合は通話終了画面を出さない
          if (this.callingModalFullscreen === false && this.callingModalMemoEmpty === true) {
            this.currentCallInfo.isAcw = false;
            this.currentCallInfo.status = 'ended';
            this.currentCallInfo = null;
            this.handleSettingIncomingCallInfo(null);
            this.updateAgentCallingStatus(false);
            await this.postRequest('/callLogClient/updateSfCase', {
              CallSid: this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid,
              createdCaseId: this.createdCaseId,
              Memo: '',
              isExtensionCallOutbound: this.isExtensionCallOutbound,
              pageUrl: window.location.href,
            }).catch(err => {
              console.error(err);
            });
            if (this.hasError) {
              setTimeout(function () {
                this.$router.go({ path: '/home', force: true });
              }, 3000);
            } else {
              this.$router.go({ path: '/home', force: true });
            }
          } else {
            await this.postRequest('/callLogClient/updateSfCase', {
              CallSid: this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid,
              createdCaseId: this.createdCaseId,
              Memo: '',
              isExtensionCallOutbound: this.isExtensionCallOutbound,
              pageUrl: window.location.href,
            }).catch(err => {
              console.error(err);
            });
            this.currentCallInfo.isAcw = true;
          }
        } else {
          this.currentCallInfo.isAcw = false;
        }
      } else {
        this.handleSettingIncomingCallInfo(null);
        this.updateAgentCallingStatus(false);
        if (this.hasError) {
          setTimeout(function () {
            this.$router.go({ path: '/home', force: true });
          }, 3000);
        } else {
          this.$router.go({ path: '/home', force: true });
        }
      }
    },
    handleCancelCall: async function (call) {
      this.isIncomming = false;
      if (this.notificationInstance.incoming) {
        this.notificationInstance.incoming.close();
      }

      // Salesforce連携がONであればケース作成
      if (this.sfAvailable === true) {
        const sendingCurrentIncomingCallInfo = {
          customerInfo: {
            phoneNumber: this.currentIncomingCallInfo.customerInfo.phoneNumber
              ? this.currentIncomingCallInfo.customerInfo.phoneNumber
              : '',
          },
        };
        await this.postRequest('/callLogClient/createSfCase', {
          CallSid: this.getCookie('CallSid') ? this.getCookie('CallSid') : this.currentCallSid,
          callInfo: sendingCurrentIncomingCallInfo,
          direction: this.directionFlg,
          pageUrl: window.location.href,
          missedFlag: true,
        }).catch(err => {
          console.error(err);
        });
      }

      this.currentIncomingCallInfo = {};
      this.hasError = false;
      //console.log("発着信可能な状態です");
      this.$router.go({ path: '/home', force: true });
      if (this.ringingBackTone) this.ringingBackTone.pause();
    },
    unsubscriberNotifyMessageInfo() {
      const self = this;
      const unsubscriber = this.firebase.observeCollection(`notifyMessageInfo`, function (data) {
        self.fetchNotifyMessageList();
      });
    },
    fetchNotifyMessageList: async function () {
      await this.postRequest('/notice/getNotifyMessageList')
        .then(res => {
          if (res.status === 'success') {
            this.noticeList = res.data;
          } else {
            this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせ情報取得'));
        });
    },
    unsubscriberOnlineStatus() {
      const self = this;
      const clientName = this.clientName;
      const onlineStatusUnsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/userStatus/onlineStatus/`,
        function (data) {
          self.onlineStatusData = data;
          if (Object.prototype.hasOwnProperty.call(data, clientName)) {
            self.updateOnlineStatus(data[self.clientName]['status']);
          }
          self.updateClientList();
        }
      );
    },
    unsubscriberCallingStatus() {
      const self = this;
      const clientName = this.clientName;
      const callingStatusUnsubscriber = this.firebase.unsubscribe(
        `realtimeDB/${this.companyID}/userStatus/callingStatus/`,
        function (data) {
          self.callingStatusData = data;
          self.updateClientList();
        }
      );
    },
    updateClientList() {
      this.forwardingUserList = [];
      for (const client of this.clientList) {
        if (
          this.callingStatusData &&
          this.callingStatusData[client.value] &&
          this.callingStatusData[client.value]['status']
        ) {
          // 通話中判定
          client.status = USER_STATUSES.CALLING;
          client.timestamp = this.callingStatusData[client.value]['timestamp'];
        } else if (this.onlineStatusData && this.onlineStatusData[client.value]) {
          // 応答可能判定
          client.status = this.onlineStatusData[client.value]['status'] ? USER_STATUSES.ONLINE : USER_STATUSES.OFFLINE;
          client.timestamp = this.onlineStatusData[client.value]['timestamp'];
        }
        this.forwardingUserList.push({
          label: client.label,
          value: client.value,
          status: client.status,
          timestamp: client.timestamp,
          // disabled: client.status === USER_STATUSES.OFFLINE || client.status === USER_STATUSES.CALLING,
        });
      }
      if (this.currentCallInfo) this.currentCallInfo.forwardingUserList = this.forwardingUserList;
    },
    handleUnlock(event) {
      event.preventDefault();
      event.returnValue = '';
    },
  },
};
</script>
